export const NEW_CASE_FROM_WEB_CREATED = "socket:NEW_CASE_FROM_WEB_CREATED";
export const NOTIFICATION_ERROR = "socket:NOTIFICATION_ERROR";